import {  Box, Modal } from "@mui/material"
import { ModalCatalogsStyles } from "./ModalCatalogsStyles";
import TabPanel from "./TabPanel";
import AddOrEditProductForm from "../AddOrEditProductForm/AddOrEditProductForm";
import { useEffect, useState } from "react";
import AddOrEditProvidenceForm from "../AddOrEditProvidenceForm/AddOrEditProvidenceForm";
import Typography from '@mui/material/Typography';
import DeleteForm from "../DeleteForm/DeleteForm";

const ModalCatalogs = ({openModal,handleCloseModal, tabValue, handleChangeTap, pathname, typeModal, productOject, fetchData}) => {

    const [showProductForm, setShowProductForm] = useState(false)
    const [showProvidcenForm, setShowProvidenceForm] = useState(false)
    const [deleteForm, setDeleteForm] = useState(false)
    const [type, setType] = useState("")
    const [titleTab1, setTitleTab1] = useState("")

    useEffect(() => {
        if (pathname.includes("/dashboard/products") && typeModal === "Edit") {
            setShowProductForm(true)
            setShowProvidenceForm(false)
            setTitleTab1("Edit product")
            setDeleteForm(false);
        } else if (pathname.includes("/dashboard/products") && typeModal === "Delete") {
            setShowProductForm(false)
            setShowProvidenceForm(false)
            setDeleteForm(true)
            setType("PRODUCT")
            setTitleTab1("Delete product")
        } else if (pathname === "/dashboard/provinces" && typeModal === "Edit"){
            setShowProductForm(false)
            setShowProvidenceForm(true)
            setTitleTab1("Edit province")
            setDeleteForm(false)
        } else if (pathname === "/dashboard/provinces" && typeModal === "Delete"){
            setShowProductForm(false)
            setShowProvidenceForm(false)
            setDeleteForm(true)
            setType("PROVINCE")
            setTitleTab1("Delete province")
        }
    },[pathname, typeModal])


    return (
        <div>
            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                component="div"
            >
                <Box sx={ModalCatalogsStyles.boxModal} component="div">
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    {titleTab1}
                </Typography>
                    <TabPanel value={tabValue} index={0} >
                        {showProductForm && <AddOrEditProductForm handleCloseModal={handleCloseModal} action="EDIT" productOject={productOject} fetchData={fetchData}/>}
                        {showProvidcenForm && <AddOrEditProvidenceForm handleCloseModal={handleCloseModal} action="EDIT" productOject={productOject} fetchData={fetchData}/>}
                        {deleteForm && <DeleteForm handleCloseModal={handleCloseModal} type={type} id={productOject.id}  fetchData={fetchData} />}
                    </TabPanel>
                </Box>
            </Modal>
        </div>   
    )
}
export default ModalCatalogs